import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
  DestroyRef,
  input,
  model,
} from '@angular/core';
import { DropdownService } from './dropdown.service';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ag-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DropdownComponent implements OnInit, OnDestroy {
  private _destroyRef = inject(DestroyRef);
  private dropdownService = inject(DropdownService);

  // Writable: toggled internally (blur / toggle / close-others)
  readonly isActive = model(false);

  readonly isRightAligned = input(false);

  readonly isSmall = input(false);

  readonly isHoverable = input(false);

  onClickSubscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.onClickSubscription = this.dropdownService.onClick
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((dropdown) => {
        if (dropdown !== this) {
          this.isActive.set(false);
        }
      });
  }

  ngOnDestroy(): void {
    this.onClickSubscription.unsubscribe();
  }

  blur() {
    this.isActive.set(false);
  }

  toggle(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isActive.update((isActive) => !isActive);
    this.dropdownService.emit(this);
  }
}
